import { createContext, useContext } from 'react';
import { ChartDataResponse } from 'services/summaryDefinitions';

export interface ChartDataContextValue {
  chartData: ChartDataResponse | null | undefined;
  isLoading: boolean;
  selectedDate?: string;
}

const ChartDataContext = createContext<ChartDataContextValue>({
  chartData: undefined,
  isLoading: false,
});

export const useChartData = () => useContext(ChartDataContext);

export default ChartDataContext;
